import { apiFetch } from './prospects.js';

export async function createCall(data) {
  return apiFetch('/calls', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function endCall(id, data) {
  return apiFetch(`/calls/${id}/end`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function fetchCalls(filters = {}) {
  const params = new URLSearchParams();
  if (filters.userId) params.set('userId', filters.userId);
  if (filters.prospectId) params.set('prospectId', filters.prospectId);
  if (filters.from) params.set('from', filters.from.toISOString());
  if (filters.to) params.set('to', filters.to.toISOString());
  const query = params.toString() ? `?${params.toString()}` : '';
  return apiFetch(`/calls${query}`);
}

export async function fetchCloserStats(userId, from, to) {
  const params = new URLSearchParams();
  params.set('userId', userId);
  if (from) params.set('from', from.toISOString());
  if (to) params.set('to', to.toISOString());
  const query = `?${params.toString()}`;
  return apiFetch(`/calls/stats/closer${query}`);
}

export async function fetchCallsByProspect(prospectId) {
  if (!prospectId) throw new Error('prospectId is required');
  return apiFetch(`/prospects/${prospectId}/calls`);
}

